import type { InvivoSceneManifest, InvivoSceneManifestEntry } from "../types/invivo_scene";

export const DEFAULT_INVIVO_SCENE_SLUG = "gamma_nail";
export const INVIVO_SCENE_MANIFEST_URL = "assets/manifest.json";

export async function loadInvivoSceneManifest({
  fetchImpl = fetch,
  manifestUrl = INVIVO_SCENE_MANIFEST_URL,
}: {
  fetchImpl?: typeof fetch;
  manifestUrl?: string;
} = {}): Promise<InvivoSceneManifest> {
  const response = await fetchImpl(manifestUrl);

  if (!response.ok) {
    throw new Error(`Failed to load invivo scene manifest from ${manifestUrl}.`);
  }

  return (await response.json()) as InvivoSceneManifest;
}

export function getInvivoSceneManifest({
  slug,
  manifest,
}: {
  manifest: InvivoSceneManifest;
  slug?: string;
}): InvivoSceneManifestEntry {
  if (typeof slug === "string" && slug.length > 0) {
    const explicitScene = manifest.scenes[slug];

    if (!explicitScene) {
      throw new Error(`Unknown invivo scene "${slug}".`);
    }

    return explicitScene;
  }

  return manifest.scenes[manifest.defaultSceneSlug];
}
